import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UserService } from 'src/app/service/user.service';
import { Router } from '@angular/router';
import { FormHelper } from 'src/app/util/formHelper';
import { Log } from 'src/app/util/log';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  @ViewChild('resetpswloader', { static: true }) loader;

  wrongEmail: boolean;
  emailNotFound: boolean;
  resetSent: boolean;

  constructor(private userService: UserService, private router: Router, private cdRef:ChangeDetectorRef) {

   }

  ngOnInit() {
  }

  resetPassword(email: string) {

    Log.debug("resetPassword: " + email);

    if (!FormHelper.isValidEmail(email)) {
      this.wrongEmail = true;
      return;
    }

    this.wrongEmail = false;
    this.emailNotFound = false;
    this.resetSent = false;

    this.loader.showLoading();

    this.userService.resetPassword(email).then(() => {

      Log.debug("reset password sent ");

      this.loader.hideLoading();
        
      this.resetSent = true;

    }).catch((error) => {

      Log.debug("error: " + JSON.stringify(error));
      // "auth/user-not-found"

      this.emailNotFound = true;
      this.loader.hideLoading();
    });
  }

}
